import { KatDataTable } from "@amzn/katal-react";
import React from "react";
import ReactDOM from "react-dom";
import type { NestTestResult } from "src/api/interfaces/nest/history";
import { NestStatusBadge } from "../../NestStatusBadge";
import "./index.css";

interface NestHistoryTableProps {
  data: NestTestResult[];
  onRowClick?: (test: NestTestResult) => void;
}

export function NestHistoryTable({ data, onRowClick }: NestHistoryTableProps) {
  const createCellFormatter = (
    renderContent: (element: HTMLDivElement, rowData: any) => void
  ) => {
    return (_: any, rowData: any, lastElement: any) => {
      const element = lastElement || document.createElement("div");
      element.className = "nest-history-clickable-cell";
      element.onclick = () => onRowClick?.(rowData._original);
      renderContent(element, rowData);
      return { element };
    };
  };

  const columns: KatDataTable.ColumnConfiguration[] = [
    {
      label: "",
      property: "submissionDate",
      formatter: createCellFormatter((el, row) => {
        el.textContent = row.submissionDate;
      }),
    },
    {
      label: "",
      property: "fileName",
      formatter: createCellFormatter((el, row) => {
        el.textContent = row.fileName;
      }),
    },
    {
      label: "",
      property: "status",
      formatter: createCellFormatter((el, row) => {
        ReactDOM.render(<NestStatusBadge status={row.status} />, el);
      }),
    },
    {
      label: "",
      property: "errors",
      formatter: createCellFormatter((el, row) => {
        el.textContent = row.errors;
      }),
    },
  ];

  const rowData = data.map((row) => ({
    submissionDate: new Date(row.submissionDate).toLocaleString(),
    fileName: row.fileName,
    status: row.status,
    errors: `${row.totalValidations - row.failedValidations}/${row.totalValidations}`,
    _original: row,
  }));

  return (
    <div className="nest-history-table-container">
      <KatDataTable
        className="nest-history-table"
        columns={columns}
        rowData={rowData}
      />
    </div>
  );
}
